module.exports = __webpack_public_path__ + "static/img/九阳太空热小净R5P.8b2e472d.png";